/**
 * 水印设置接口 
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WatermarkService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 水印设置接口
  /**
   * 保存水印信息
   * @param param
   * @returns {Observable<any>}
   */
  saveWaterImageInfo(param) {
    const url = this.filefix + 'refFileObject/save';
    return this.http.Post(url, param);
  }

  /**
   * 获取保存图片的信息
   * @param param
   * @returns {Observable<any>}
   */
  queryWaterImagePageList(param) {
    const url = this.filefix + 'refFileObject/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 根据系统缓存 获取当前登录用户组织信息
   * @param param
   * @returns {Observable<any>}
   */
   getCurrentOrgId(param) {
    const url = this.prefix + 'common/queryUserCache?type=1&systemId='+param.systemId;
    return this.http.Get(url);
  }
  //#endregion

}
